import { Component, Input } from "@angular/core";

@Component({
  selector: 'lists-skeleton',
  templateUrl: './lists-skeleton.component.html',
  styleUrls: ['./lists-skeleton.component.scss'],
})
export class ListsSkeletonComponent {

  @Input()
  showTabs = true;
}
